import { serviceGetOperations } from '@/shared/api/operations';
import { EVENT_NEW_OPERATION } from '@/shared/lib/events/eventsConstants';
import { Operation } from '@/shared/lib/types/card';
import { ServiceListResponse } from '@/shared/lib/types/common';
import { useEventsStore } from '@/shared/store/useEventsStore';
import { useUserStore } from '@/shared/store/useUserStore';

const GENERATOR_KEY = 'generateOperationChangeEvent';

export function eventsByOperationsGenerate() {
  const userStore = useUserStore();
  const eventsStore = useEventsStore();
  const genState = eventsStore.generatorState(GENERATOR_KEY);
  const lastInStore = userStore.getUserInfo
    .allOperations[userStore.getUserInfo.allOperations.length - 1] as any;
  const lastOperationId = lastInStore?.id ?? genState?.lastOperationId;

  serviceGetOperations({
    params: {
      email: userStore.getUserInfo.userEmail,
    },
  }).success((v: ServiceListResponse<'operations', Operation>) => {
    const lastOperation = v.response.operations[v.response.operations.length - 1];

    if (lastOperation.id !== lastOperationId) {
      const newOperations = v.response.operations.filter(
        operation => operation.id > lastOperationId,
      );
      newOperations.forEach(operation => {
        eventsStore.addEvent({
          type: EVENT_NEW_OPERATION,
          title: 'Новая операция',
          body: 'обновление моей истории',
        });
      });
    }

    eventsStore.addGeneratorState({
      generator: GENERATOR_KEY,
      state: {
        lastOperationId: lastOperation.id,
      },
    });
  });
}
